export default {
    fields: {
        active: 'Active',
        sessionLink: 'Session Link',
        archived: 'Archived',
        duration: 'Duration',
        code: 'Confirm Code',
        joinBeforeHost: 'Join Before Host',
        joinBeforeHostTime: 'Join Before Host Time',
        waitingRoom: 'Waiting Room',
        percentOff: 'Percent off',
        amountOff: 'Amount off',
        completed: 'Completed',
        daysMeditated: 'Days meditated',
        durationInMonths: 'Duration in months',
        discountType: 'Discount type',
        discountOff: 'Discount off',
        coupon: 'Coupon',
        maxRedemptions: 'Max redemptions',
        redeemBy: 'Redeem by',
        id: 'ID',
        name: 'Name',
        assignedToAll: 'Assign to all',
        sendPush: 'Send Push Notifications',
        isSuggested: 'Is suggested',
        inactive: 'Inactive',
        coverImage: 'Cover image',
        choose: 'Choose',
        lastName: 'Last Name',
        fullName: 'Full Name',
        email: 'Email',
        role: 'Role',
        password: 'Password',
        domain: 'Domains',
        launchDate: 'Launch date',
        launchTime: 'Launch time',
        uploadVideo: 'Upload video',
        current_password: 'Current Password',
        password_confirm: 'Password Confirm',
        confirm_password: 'Confirm Password',
        select_role: 'Select Role',
        phone: 'Phone',
        phoneNumber: 'Phone Number',
        search: 'Search by Text',
        fullNAme: 'Full Name',
        city: 'City',
        state: 'State',
        country: 'Country',
        department: 'Department',
        label: 'Label',
        type: 'Type',
        required: 'Required',
        fieldTitle: 'Custom Field Title',
        fieldType: 'Field Type',
        businessName: 'Business Name',
        organizationName: 'Organization’s Name',
        organizationSize: 'Organization’s Estimated Size',
        organizationsSize: 'Organization’s Size',
        programName: 'Program Title',
        landingPageTitle: 'Landing Page Title',
        resendCode: 'RESEND VERIFICATION CODE',
        meditations: 'Meditations',
        comment: 'Comment',
        completedSessions: 'Completed',
        contactName: 'Contact Name / Champion',
        contactEmail: 'Champion Email',
        contactPhone: 'Contact Phone',
        status: 'Status',
        maxUsers: 'Total Numbers of Members',
        sessionName: 'Meditation Name',
        assignInstructor: 'Assign Instructor',
        instructor: 'Instructor',
        assignBusiness: 'Assign Business',
        sessionDescription: 'Description',
        selectExpiration: 'Select Expiration',
        selectSession: 'Select Meditation',
        startTime: 'Start Time',
        startDate: 'Start Date',
        showDate: 'Show Date',
        showTime: 'Show Time',
        sendDate: 'Send Date',
        sendTime: 'Send Time',
        endDate: 'End Date',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        date: 'Date',
        userCapacity: 'Member Capacity',
        dateRange: 'Date Range',
        position: 'Position',
        information: 'Personal Information',
        image: 'Choose Image',
        locked: 'Lock meditation',
        challenge: 'Participate In Challenge',
        rating: 'Rating',
        subject: 'Subject',
        title: 'Header',
        description: 'Description',
        createdAt: 'Date Created',
        positionTitle: 'Title',
        body: 'Message',
        company: 'Company Name',
        companySize: 'Company Size',
        tags: 'Tags',
        themes: 'Themes',
        theme: 'Theme',
        cardNumber: 'Card Number',
        monthExp: 'Expiration Month',
        yearExp: 'Expiration Year',
        CVV: 'CVV',
        cardHolder: 'Name on card',
        zipCode: 'Zip Code',
        packageType: 'Subscription Plan',
        timesRedeemed: 'Times Redeemed',
        valid: 'Valid',
        showDataBy: 'Show data by',
        noteTitle: 'Note Title',
        noteText: 'Note Text',
        endTime: 'End Time',
        noteCategory: 'Note Category',
        useDefaultImage: 'Use default image',
        enableChillCheckIn: 'Enable CHILL Check-in',
        author: 'Author',
        feedLabel: 'Feed Label'
    }
};
